import React, { useState } from "react";
import {
  randomBetweenToNumber,
  removeSepMoney,
  sepJustMoney,
  ToTimeHM,
} from "../../../../../../Common/Function";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Stack from "@mui/material/Stack";
import { daysOfWeek } from "../../../../../../../Utils/contstant";
import { Button, TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import toast from "react-hot-toast";
const Form = ({ form, setForm, inputs, week = false }) => {
  const isValid = type => {
    let result = false;
    if (type == "default") {
      result = true;
    } else {
      if (form.option && form.option[type]) {
        result = true;
      }
    }
    return result;
  };
  const [time, setTime] = useState({});

  const addTime = () => {
    let obj = {};

    if (week) {
      if (time.day) {
        if (form.times[time.day]) {
          obj = {
            ...form.times,
            [time.day]: [
              ...form.times[time.day],
              { ...time, _id: randomBetweenToNumber(100, 1000000000) },
            ],
          };
        } else {
          obj = {
            ...form.times,
            [time.day]: [
              { ...time, _id: randomBetweenToNumber(100, 1000000000) },
            ],
          };
        }
        setForm({
          ...form,
          times: obj,
        });
      }
    } else {
      setForm({
        ...form,
        times: [
          ...form.times,
          { ...time, _id: randomBetweenToNumber(100, 1000000000) },
        ],
      });
    }
  };

  const renderInputs = ({ input, label, key, type }) => {
    switch (input) {
      case "number":
        if (isValid(type)) {
          return (
            <div className="col-4 mb-4" key={key}>
              <TextField
                fullWidth
                type="text"
                min={0}
                label={label}
                // size="small"
                value={sepJustMoney(time[key])}
                onChange={({ target: { value } }) => {
                  setTime({ ...time, [key]: removeSepMoney(value) });
                }}
              />
            </div>
          );
        }
        break;

      case "time":
        return (
          <div className="col-4 mb-4">
            <LocalizationProvider dateAdapter={AdapterDateFns} key={key}>
              <Stack spacing={3}>
                <TimePicker
                  ampm={false}
                  size="small"
                  openTo="hours"
                  views={["hours", "minutes"]}
                  minutesStep={5}
                  inputFormat="HH:mm"
                  mask="__:__"
                  label={label}
                  value={time[key + "s"] || new Date()}
                  onChange={newValue => {
                    setTime({
                      ...time,
                      [key]: ToTimeHM(newValue),
                      [key + "s"]: newValue,
                    });
                  }}
                  renderInput={params => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>{" "}
          </div>
        );
        break;

      case "select":
        if (isValid(type)) {
          return (
            <div className="col-4 mb-4" key={key}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={label}
                  onChange={({ target: { value } }) => {
                    setTime({ ...time, gender: value });
                  }}
                >
                  {[
                    {
                      label: "انتخاب کنید",
                      key: "false",
                    },
                    {
                      label: "آقایان",
                      key: "man",
                    },
                    {
                      label: "بانوان",
                      key: "woman",
                    },
                  ].map((option, key) => {
                    return (
                      <MenuItem value={option.key} key={key}>
                        {" "}
                        {option.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          );
        }

        break;

      case "date":
        break;
      case "text":
        if (isValid(type)) {
          return (
            <div className="col-4 mb-4" key={key}>
              <TextField
                fullWidth
                label={label}
                // size="small"
                value={time[key]}
                onChange={({ target: { value } }) => {
                  setTime({ ...time, [key]: value });
                }}
              />
            </div>
          );
        }
        break;

      default:
        break;
    }
  };
  const validateTime = () => {
    let res = {
      status: true,
      msg: "",
    };
    inputs.map(({ input, label, key, type }) => {
      if (isValid(type)) {
        if (!time[key]) {
          res = { status: false, msg: res.msg + label + " , " };
        }
      }
    });
    return res;
  };
  const renderToast = msg => {
    toast.error(msg + "وارد نشده است");
  };

  return (
    <div>
      <div className="row mt-2">
        {inputs &&
          inputs.map(input => {
            return renderInputs(input);
          })}
        {week && (
          <div className="col-4 mb-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                {"روز های هفته"}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={"روز های هفته"}
                onChange={({ target: { value } }) => {
                  setTime({ ...time, day: value });
                }}
              >
                {daysOfWeek.map((option, key) => {
                  return (
                    <MenuItem value={option.key} key={key}>
                      {" "}
                      {option.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        )}
      </div>
      <div className="row mt-2">
        <div className="col">
          <button
            className="btn btn-primary"
            onClick={() => {
              if (validateTime()["status"]) {
                addTime();
              } else {
                renderToast(validateTime()["msg"]);
              }
            }}
          >
            ثبت
          </button>
        </div>
      </div>
    </div>
  );
};

export default Form;
